'use client';

import { LogoList } from '@/app/components/server/logo-list';
import type { DatoCompany, DatoModuleFormat } from '@/lib/datocms';

import type { FlexProps } from '@ironhack/design-system2/components';
import type { ReactElement } from 'react';

export type CompanyList = {
  logos: DatoCompany[];
  subtitle: string;
  title: string;
};

type Props = { data: CompanyList } & FlexProps;

export const CompanyList = (props: Props): ReactElement => {
  const {
    data: { title, subtitle, logos = [] },
    ...flexProps
  } = props;

  const logoListData = {
    logos,
    moduleFormat: [
      { background: 'light', spacingBottom: '80', spacingTop: '0' },
    ] as [DatoModuleFormat],
    subtitle,
    title,
  };

  return <LogoList as="section" data={logoListData} {...flexProps} />;
};
